<template>
  <div class="plan-calendar">
    <PlanCalendarToolbar
      v-model:view="view"
      :month-label="monthLabel"
      :has-plan="hasPlan"
      :plan-unknown="planUnknown"
      :can-plan-next="canPlanNext"
      :creating="creating"
      @prev="movePrev"
      @next="moveNext"
      @create-plan="emit('create-plan')"
      @delete-plan="emit('delete-plan')"
    />

    <p
      v-if="outsideView"
      class="plan-calendar__outside"
    >
      <v-icon
        icon="mdi-information-outline"
        size="16"
      />
      {{ t(`marketing-agent.calendar.${outsideView}`) }}
    </p>

    <PlanMonthGrid
      v-if="isMonth"
      :weekday-labels="weekdayLabels"
      :days="monthDays"
      :slots="slots"
      :creatable="creatable"
      @slot-click="emit('slot-click', $event)"
      @create-slot="emit('create-slot', $event)"
    />
    <PlanWeekGrid
      v-else
      :days="isDay ? dayDays : weekDays"
      :slots="slots"
      :creatable="creatable"
      :show-no-activity="showNoActivity"
      @slot-click="emit('slot-click', $event)"
      @create-slot="emit('create-slot', $event)"
    />
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'

import PlanCalendarToolbar from './calendar/PlanCalendarToolbar.vue'
import PlanMonthGrid from './calendar/PlanMonthGrid.vue'
import PlanWeekGrid from './calendar/PlanWeekGrid.vue'
import { useCalendarView } from './calendar/useCalendarView'

const props = defineProps({
  slots: {
    type: Array,
    default: () => [],
  },
  creatable: {
    type: Boolean,
    default: false,
  },
  showNoActivity: {
    type: Boolean,
    default: false,
  },
  hasPlan: {
    type: Boolean,
    default: false,
  },
  // Loading, or the load failed: whether a plan exists is not known yet.
  planUnknown: {
    type: Boolean,
    default: false,
  },
  canPlanNext: {
    type: Boolean,
    default: false,
  },
  creating: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['slot-click', 'create-slot', 'create-plan', 'delete-plan'])

const { t } = useI18n()
const {
  view,
  isMonth,
  isDay,
  dayDays,
  weekDays,
  monthDays,
  monthLabel,
  weekdayLabels,
  outsideView,
  movePrev,
  moveNext,
} = useCalendarView(() => props.slots)
</script>

<style scoped>
.plan-calendar {
  display: flex;
  flex-direction: column;
  min-height: 0;
  height: 100%;
}
.plan-calendar__outside {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 8px 8px;
  padding: 8px 12px;
  border-radius: 8px;
  background: rgba(var(--v-theme-primary), 0.08);
  color: #1f1f1f;
  font-size: 13px;
  line-height: 1.4;
}
</style>
